import { PropertyDefinitionConfig } from '../types';

/** Pseudo-repository metadata for chart UI labels. */
export const CHART_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idChartRepository',
	singular: 'Chart',
};
